import React, { useState } from "react";
import { SEARCH_ICON, cufrontIcons } from "../../cufront-assets/icons/Icons";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import moment from "moment";
// import { calcLength } from "framer-motion";
import { calculateAge } from "../../_helper/constant/constant";
import { filterByTagType } from "../views/CustomField";
import { doctorSettingAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
const Visit = ({
  previousVisits,
  allergies,
  advices,
  patientHistory,
  userDetails,
}) => {
  // const [showDetails, setShowDetails] = useState(true);
  const [showDetailsArray, setShowDetailsArray] = useState(
    Array(previousVisits.length).fill(false)
  );
  const [doctorSetting] = useAtom(doctorSettingAtom);

  // //(
  //   "doctorSetting--------",
  //   JSON.stringify(doctorSetting?.consultation_setup, null, 2)
  // );

  // //("presvious visit--------", previousVisits);
  //   //("Allergies--------", allergies);
  // //("advice--------", advices);
  //   //("paitent history--------", patientHistory);
  // //("userDetails--------", userDetails);
  const toggleShowDetails = (index) => {
    const newShowDetailsArray = [...showDetailsArray];
    newShowDetailsArray[index] = !newShowDetailsArray[index];
    setShowDetailsArray(newShowDetailsArray);
  };

  const getTagId = (label) => {
    const setting = doctorSetting?.consultation_setup.find(
      (item) => item.label.toLowerCase() === label.toLowerCase()
    );
    return setting ? setting.tagId : null;
  };

  return (
    <div>
      <div className="w-full h-fulll">
        <div className="w-full h-[75px] border flex items-center text-[10.85px] lg:text-[10.85px] xl:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px]  leading-[12.85px] lg:leading-[13.63px] xl:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px] font-bold px-6">
          Patient Name : {userDetails?.length > 0 && userDetails[0]?.full_name}
        </div>
        <div className="w-full flex justify-between items-center px-4">
          <div className="cu-input-search-filter-div my-4 md:w-[327.7px] lg:h-[28.44px] xl:w-[409.63px] xl:h-[35.56px] 2xl:w-[437.16px] 2xl:h-[37.94px] xlarge:w-[614.44px] xlarge:h-[53.33px]">
            <input
              type="search"
              placeholder="Search"
              //   onChange={handleInputChange}
            />

            <img className="all-p-search-icon" src={SEARCH_ICON} alt="" />
            <div className="cu-all-filter">
              <img
                className="all-p-search-icon"
                src={cufrontIcons.filter}
                alt=""
              />
            </div>
          </div>
          <div className="text-[10.85px] lg:text-[10.85px] xl:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px]  leading-[12.85px] lg:leading-[13.63px] xl:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px]">
            Total Prescription : {previousVisits.length}
          </div>
        </div>
        {previousVisits?.map((item, i) => {
          return (
            <div className="border px-4">
              <div
                className="min-h-[78px] w-full -b flex justify-between items-center cursor-pointer"
                onClick={() => toggleShowDetails(i)}
              >
                <div className="text-[10.85px] lg:text-[10.85px] xl:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px]  leading-[12.85px] lg:leading-[13.63px] xl:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px]">
                  Visit Date:-{" "}
                  {moment(item?.date_created).format("MMMM DD, YYYY")}
                </div>
                <div className="w-[50%] flex  justify-between items-center cursor-pointer">
                  <div className="w-[85%] flex flex-wrap text-[10.85px] lg:text-[10.85px] xl:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px]  leading-[12.85px] lg:leading-[13.63px] xl:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px]">
                    {/* {filterByTagType(item?.qp_cm_consultation_tags, 4)?.map(
                      (el, i) => {
                        return (
                          <>
                            <span>{el?.name}, </span>
                          </>
                        );
                      }
                    )} */}
                    {filterByTagType(
                      item?.qp_cm_consultation_tags,
                      getTagId("COMPLAINTS")
                    )?.map((el, i) => {
                      return (
                        <>
                          <span key={i}>{`${el?.name}${
                            i ===
                            filterByTagType(
                              item?.qp_cm_consultation_tags,
                              getTagId("COMPLAINTS")
                            )?.length -
                              1
                              ? ""
                              : ", "
                          }`}</span>
                        </>
                      );
                    })}
                  </div>
                  <span className="cursor-pointer">
                    {showDetailsArray[i] ? (
                      <IoIosArrowUp />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </span>
                </div>
              </div>
              <div
                className="h-full
             overflow-auto"
              >
                {showDetailsArray[i] && (
                  <div>
                    <div className=" h-full overflow-auto text-[10.85px] lg:text-[10.85px] xl:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px]  leading-[12.85px] lg:leading-[13.63px] xl:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px]">
                      <div className="w-full flex my-2 py-4 border-b border-[#00000033] gap-2">
                        <div className="w-[65%] flex-1 flex gap-4 flex-wrap pr-4">
                          <span>
                            {userDetails?.length > 0 &&
                              userDetails[0]?.full_name}
                          </span>
                          <span>
                            {calculateAge(
                              userDetails?.length > 0 && userDetails[0]?.age
                            )}
                            Years
                          </span>
                          <span className="uppercase">
                            {userDetails?.length > 0 &&
                              userDetails[0]?.gender.split("")[0]}
                          </span>{" "}
                          <span>
                            {userDetails?.length > 0 && userDetails[0]?.phone}
                          </span>
                        </div>
                        <div className=" flex justify-center gap-3">
                          <span>Visit :-</span>
                          <span>
                            {moment(item?.date_created).format("MMMM DD, YYYY")}
                          </span>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Complaints
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="mb-1 lg:leading-[17.75px]">
                            -{""}
                            {filterByTagType(
                              item?.qp_cm_consultation_tags,
                              getTagId("COMPLAINTS")
                            )?.map((el, i) => {
                              return (
                                <span key={i}>{`${el?.name}${
                                  i ===
                                  filterByTagType(
                                    item?.qp_cm_consultation_tags,
                                    getTagId("COMPLAINTS")
                                  )?.length -
                                    1
                                    ? ""
                                    : ", "
                                }`}</span>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Allergies
                        </div>
                        <div className="flex-1 flex items-center">
                          -{" "}
                          {allergies.map((el, i) => {
                            return (
                              <span key={i}>
                                <span>{`${el?.name}${
                                  i === allergies?.length - 1 ? "" : ", "
                                }`}</span>
                              </span>
                            );
                          })}
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Advice & Direction
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="lowercase mb-1 lg:leading-[17.75px]">
                            - {item?.qp_cm_advices?.description}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Test & Investigations
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="lowercase mb-1 lg:leading-[17.75px]">
                            -{" "}
                            {filterByTagType(
                              item?.qp_cm_consultation_tags,
                              getTagId("TEST & INVESTIGATION")
                            )?.map((el, i) => {
                              return (
                                <span key={i}>{`${el?.name}${
                                  i ===
                                  filterByTagType(
                                    item?.qp_cm_consultation_tags,
                                    getTagId("TEST & INVESTIGATION")
                                  )?.length -
                                    1
                                    ? ""
                                    : ", "
                                }`}</span>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Diagnosis
                        </div>
                        <div className="flex-1 ">
                          <div className="lowercase mb-1 lg:leading-[17.75px]">
                            -{" "}
                            {filterByTagType(
                              item?.qp_cm_consultation_tags,
                              getTagId("DIAGNOSIS")
                            )?.map((el, i) => {
                              return (
                                <span key={i}>{`${el?.name}${
                                  i ===
                                  filterByTagType(
                                    item?.qp_cm_consultation_tags,
                                    getTagId("DIAGNOSIS")
                                  )?.length -
                                    1
                                    ? ""
                                    : ", "
                                }`}</span>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Medical History
                        </div>
                        <div className="flex-1 ">
                          -{" "}
                          <>
                            {patientHistory.map((el, i) => {
                              <>
                                {/* {"-"} */}
                                <span key={i}>{`${el?.name}${
                                  i === patientHistory?.length - 1 ? "" : ", "
                                }`}</span>
                                ;
                              </>;
                            })}
                          </>
                        </div>
                      </div>
                      {item?.qp_cm_vitals.length > 0 && (
                        <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                          <div className="w-[25%] text-[#6D6D6D] flex justify-start items-center">
                            Vitals
                          </div>
                          <div className="w-full h-full overflow-x-auto">
                            <table className="table-auto w-full">
                              <thead>
                                <tr className="bg-[#EBF8EC]">
                                  {item?.qp_cm_vitals.map((el, i) => {
                                    return (
                                      <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                        {el?.type?.label}
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                <tr className="text-sm">
                                  {item?.qp_cm_vitals.map((el, i) => {
                                    return (
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {el?.value1} {el?.type?.unit}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {item?.medicine_data.length > 0 && (
                        <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                          <div className="w-[25%] text-[#6D6D6D] flex justify-start items-center">
                            Medicine Details
                          </div>
                          <div className="w-full h-full overflow-x-auto">
                            <table className="table-auto w-full">
                              <thead>
                                <tr className="bg-[#EBF8EC]">
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Medicine
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Dosage
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Unit
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    When
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Frequency
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Duration
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] lg:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Notes
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                {item?.medicine_data.map((item, i) => {
                                  return (
                                    <tr className="text-sm">
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.medicineName}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.unit.name}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.dosage.name}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.when.name}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.frequency.name}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.duration}
                                      </td>
                                      <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                        {item?.notes.name}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Visit;
